import { Drawer } from 'antd'
import React, { useCallback, useState } from 'react'
import GridFilter from 'grid-filter/GridFilter'
import { AND_PASS } from '../grid-filter/GridFilter'

const FilterContext = React.createContext(null)

export const getGridPropsObj = (headers, data, setFilterData) => {
  return {
    headers: headers || [],
    data: data || [],
    setFilterData: setFilterData || (_ => _),
  }
}
export const emptyFilterObj = {
  data: [],
  headers: [],
  setFilterData: _ => _,
}
export const effectvieFilterCount = filters => {
  return filters.filter(f => !!f.enabled).filter(f => !!f.ident).length
}

export const FilterContextProvider = ({ children }) => {
  const [placement, setPlacement] = useState('top')
  const [visible, setVisible] = useState(false)
  const [filterCondition, setFilterCondition] = useState([{}])
  const [andOrPass, setAndOrPass] = useState(AND_PASS)

  const [gridPros, setGridProps] = useState(emptyFilterObj)

  const onClose = _ => {
    setVisible(false)
  }

  const setGridPropsData = useCallback((gp, doClean = true) => {
    setGridProps(gp)
    if (doClean) setFilterCondition([{}])
  }, [])

  return (
    <FilterContext.Provider
      value={{
        placement,
        setPlacement,
        setDrawerVisible: setVisible,
        setGridProps: setGridPropsData,
        // setGridPropsData,
        setFilterCondition,
        filterCondition,
      }}
    >
      {children}

      <Drawer
        placement={placement}
        closable
        onClose={onClose}
        visible={visible}
        bodyStyle={{
          paddingTop: 5,
          paddingBottom: 5,
          overflow: 'hidden',
          height: 350,
        }}
        style={{ overflow: 'hidden' }}
        drawerStyle={{ overflow: 'hidden', height: 350 }}
        maskStyle={{ backgroundColor: 'transparent' }}
      >
        <GridFilter
          header={gridPros.headers}
          data={gridPros.data}
          setFilterData={gridPros.setFilterData}
          filterCondition={filterCondition}
          setFilterCondition={setFilterCondition}
          andOrPass={andOrPass}
          setAndOrPass={setAndOrPass}
        />
      </Drawer>
    </FilterContext.Provider>
  )
}

export default FilterContext
